import {
    DEVICES_BY_STATUS_REQUEST,
    DEVICES_BY_STATUS_RESULT
} from 'Redux/actionTypes';
export const devicesByStatusRequest = (data) => ({
    type: DEVICES_BY_STATUS_REQUEST,
    payload: data
})

export const devicesByStatusResult = (data, id, clear) => ({
    type: DEVICES_BY_STATUS_RESULT,
    payload: { data, id, clear }
})